import { HTTP } from '../../utils'
import { getItem } from '../../storage'

export const getResults = (data) => {
  let url = '/elasticsearch/' + data.indexList + '/search?libraryIdList=' + data.libraryList
  if (data.useDefaultFields === false || data.useDefaultFields === 'false') {
    url += '&useDefaultFields=false'
  }
  return getItem('token').then(token => {
    return HTTP(token).post(url, data.payload)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/app/search/api.js